let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("l6YHr")).then(() => parcelRequire('4VjzZ'));